import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'api-validation-error',
  templateUrl: './api-validation-error.component.html'
})
export class ApiValidationErrorComponent {

  @Input()
  public field: FormControl;

  public hasApiValidationError(): boolean {
    return this.field.hasError('apiValidation');
  }

  public getApiValidationError(): string {
    return this.field.getError('apiValidation');
  }

}



// WEBPACK FOOTER //
// /dist/src/app/shared/api-validation/api-validation-error/api-validation-error.component.ts